import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import { Megaphone, ExternalLink, Paperclip, ArrowUpRight, AlertTriangle } from "lucide-react";
import { fmtDateIST } from "../lib/datetime";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AnnouncementsWidget() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/announcements/top").then(({ data }) => setItems(data || [])).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <div className="pk-depth pk-depth-pink relative overflow-hidden rounded-xl group" data-testid="dashboard-announcements">
      <div className="absolute -top-10 -right-10 w-32 h-32 bg-pink-200/40 rounded-full blur-3xl pointer-events-none" />
      <div className="absolute -bottom-12 -left-12 w-32 h-32 bg-amber-200/30 rounded-full blur-3xl pointer-events-none" />
      <div className="relative flex items-center justify-between px-5 py-3.5 border-b border-pink-100/70">
        <div className="flex items-center gap-2">
          <Megaphone size={22} strokeWidth={2} className="text-pink-600 shrink-0 group-hover:scale-110 transition-transform" />
          <div>
            <div className="text-[10px] uppercase tracking-[0.16em] text-pink-700 font-bold">From Leadership</div>
            <h3 className="heading text-base font-bold text-slate-900 leading-tight">Latest Announcements</h3>
          </div>
        </div>
        <Link to="/m/announcements" className="inline-flex items-center gap-0.5 px-3 py-1.5 rounded-full bg-white/80 border border-pink-200 text-[10.5px] font-bold text-pink-700 hover:bg-pink-50 transition-all" data-testid="dashboard-ann-viewall">
          View all <ArrowUpRight size={11} />
        </Link>
      </div>
      <div className="relative divide-y divide-pink-100/70">
        {items.map((a) => (
          <div key={a.id} className="px-5 py-3 hover:bg-white/40 transition-colors" data-testid={`dashboard-ann-${a.id}`}>
            <div className="flex items-start justify-between gap-3 flex-wrap">
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  {a.important && <AlertTriangle size={12} className="text-rose-500" />}
                  <div className="text-sm font-semibold text-slate-900 truncate">{a.title}</div>
                  <span className="text-[10px] mono text-slate-500">{fmtDateIST(a.published_at || a.created_at)} · {a.created_by_name}</span>
                </div>
                {a.body && <p className="text-[12.5px] text-slate-600 mt-1 line-clamp-2 whitespace-pre-wrap">{a.body}</p>}
                <div className="flex items-center gap-3 mt-1.5 flex-wrap">
                  {a.external_url && (
                    <a href={a.external_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[11px] font-semibold text-[var(--pk-accent)] hover:underline">
                      <ExternalLink size={10} /> Open Link
                    </a>
                  )}
                  {a.attachment_id && (
                    <a href={`${BACKEND}/api/announcements/${a.id}/attachment`} className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-700 hover:text-slate-900">
                      <Paperclip size={10} /> {a.attachment_name}
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
